const state = {
  userId: null,
  firstName: null,
  lastName: null,
  imageUrl: null,
  email: null,
  role: null,
  address: {
    country: '',
    province: '',
    district: '',
    subDistrict: '',
    zipCode: '',
    approveNumber: null,
    telephone: '',
    detail: ''
  },
  theme: {
    colorMenu: '',
    colorMain: '',
    colorSecond: ''
  },
  tokenExpire: null,
  accessToken: null,
  clinicId: null,
  clinicName: null,
  vatType: null
}

const actions = {
  setClinic ({ commit }, payload) {
    commit('SET_CLINIC', payload)
  },
  logout ({ commit }) {
    commit('CLINIC_LOGOUT')
  },
  setClinicImageUrl ({ commit }, payload) {
    commit('SET_IMAGEURL', payload)
  },
  setClinicName ({ commit }, payload) {
    commit('SET_CLINICNAME', payload)
  },
  setClinicAddress ({ commit }, payload) {
    commit('SET_CLINIC_ADRESS', payload)
  },
  setTheme ({ commit }, payload) {
    commit('SET_CLINIC_THEME', payload)
  },
  setClinicVatType ({ commit }, payload) {
    commit('SET_CLINIC_VAT_TYPE', payload)
  }

}

const mutations = {
  SET_CLINIC_VAT_TYPE (state, payload) {
    state.vatType = payload
  },
  SET_CLINIC_ADRESS (state, payload) {
    state.address = { ...payload }
  },
  SET_CLINIC_THEME (state, payload) {
    state.theme = { ...payload }
  },

  SET_IMAGEURL (state, payload) {
    state.imageUrl = payload
  },
  SET_CLINICNAME (state, payload) {
    state.clinicName = payload
  },
  SET_CLINIC (state, payload) {
    state.userId = payload.userId
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.imageUrl = payload.imageUrl
    state.email = payload.email
    state.role = payload.role
    state.clinicId = payload.clinicId
    state.clinicName = payload.clinicName
    state.tokenExpire = payload.tokenExpire
    state.accessToken = payload.accessToken
  },
  CLINIC_LOGOUT (state) {
    state.userId = null
    state.firstName = null
    state.lastName = null
    state.imageUrl = null
    state.email = null
    state.role = null
    state.clinicId = null
    state.clinicName = null
    state.tokenExpire = null
    state.accessToken = null
    state.address = null
    state.theme = null
  }
}

const getters = {
  clinic: (state) => ({ ...state }),
  accessToken: (state) => state.accessToken,
  tokenExpire: (state) => state.tokenExpire
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
